import {
    apiRequest,
    rumpunDetail,
    rumpunUpdate
} from "../../../../../services/adapters/kepegawaian/rumpunService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", rumpunDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", rumpunUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository